import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { pisCofinsCstOptions } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.const';
import { InvoiceItemFormValues } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Card, Col, Form, FormInstance, Row, Select, Space } from 'antd';

interface NoteItemsPisTabsFormProps {
  form: FormInstance<InvoiceItemFormValues>;
}

export default function NoteItemsPisTabsForm({
  form,
}: NoteItemsPisTabsFormProps) {
  return (
    <Form form={form}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Card title="PIS" type="inner" style={{ marginBottom: 24 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8} lg={24}>
              <FloatingFormItem label="CST" name={['itemTaxes', 'pisCst']}>
                <Select allowClear options={pisCofinsCstOptions} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota (%)"
                name={['itemTaxes', 'pisAliquot']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem label="Valor" name={['itemTaxes', 'pisValue']}>
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Base de cálculo"
                name={['itemTaxes', 'pisBaseCalculationValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Quantidade vendida"
                name={['itemTaxes', 'pisSoldQuantity']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota reais"
                name={['itemTaxes', 'pisRealAliquot']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>

        <Card title="PIS ST" type="inner">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'pisStAliquot']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'pisStValue']}
              >
                <InputText onlyNumber />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Base de cálculo"
                name={['itemTaxes', 'pisStBaseCalculation']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Quantidade vendida"
                name={['itemTaxes', 'pisStSoldQuantity']}
              >
                <InputText onlyNumber />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Aliquota reais"
                name={['itemTaxes', 'pisStRealAliquot']}
              >
                <InputText onlyNumber />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>
      </Space>
    </Form>
  );
}
